"use client";

/**
 * Beta 04.06.x (11/06/2026): inicializa scroll/section tracking na landing.
 * Importar no Hero ou raiz da landing pra montar listeners de scroll + section view.
 */
import { useEffect } from 'react';
import { initLandingTracking } from '@/lib/analytics/dataLayer';

export function LandingTracker() {
  useEffect(() => {
    initLandingTracking();
  }, []);
  return null;
}
